import { Grid, IconButton, TextField, Typography } from "@mui/material";

import { TRANSFER_SIDES } from "../contstants";
import { motion } from "framer-motion";
import { useFormContext } from "react-hook-form";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

function TransferSide({ transferInitial }) {
  const [searchParams, setSearchParams] = useSearchParams();

  const { watch } = useFormContext();
  const sideId = watch("sideId");

  const handleChangeSideId = () => {
    const allSearchParams = Object.fromEntries([...searchParams]);
    if (sideId === TRANSFER_SIDES.MARGIN_TO_SPOT) {
      setSearchParams({
        ...allSearchParams,
        transferSideId: TRANSFER_SIDES.SPOT_TO_MARGIN,
      });
    } else if (sideId === TRANSFER_SIDES.SPOT_TO_MARGIN) {
      setSearchParams({
        ...allSearchParams,
        transferSideId: TRANSFER_SIDES.MARGIN_TO_SPOT,
      });
    }
  };

  const fromAndToFields = useMemo(() => {
    if (sideId === TRANSFER_SIDES.MARGIN_TO_SPOT) {
      return {
        to: 137,
        from: -137,
      };
    } else
      return {
        to: 0,
        from: 0,
      };
  }, [sideId]);

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="label" color="text.secondary">
          From
        </Typography>

        <motion.div animate={{ y: fromAndToFields.to }}>
          <TextField
            inputProps={{
              readOnly: true,
            }}
            value="Spot Wallet"
          />
        </motion.div>
      </Grid>

      <Grid item xs={12} textAlign="center">
        <IconButton color="secondary" onClick={handleChangeSideId}>
          <ion-icon name="swap-vertical-outline"></ion-icon>
        </IconButton>
      </Grid>

      <Grid item xs={12} sx={{ paddingTop: "0 !important" }}>
        <Typography variant="label" color="text.secondary">
          To
        </Typography>

        <motion.div animate={{ y: fromAndToFields.from }}>
          <TextField
            inputProps={{
              readOnly: true,
            }}
            value="Margin Wallet"
          />
        </motion.div>
      </Grid>
    </>
  );
}

export default TransferSide;
